module.exports = __webpack_public_path__ + "img/hr-tree-06-i-leaves.6f109aec.png";